export function displayError(input, errorMessage) {
    const errorSpan = document.createElement('span');
    errorSpan.classList.add('error-message');
    errorSpan.textContent = errorMessage;
    input.parentNode.insertBefore(errorSpan, input.nextSibling);
}
